import { useEffect } from "react";
import { useRoutes } from "../../hooks/use-routes";
import { useOrderingStore } from "../../store/use-ordering-store";

export const useRedirectIfNoVerificationType = () => {
  const { goToRegistration } = useRoutes();
  const { verificationType } = useOrderingStore();

  useEffect(() => {
    if (!verificationType) {
      goToRegistration();
    }
  }, [verificationType, goToRegistration]);
};
